/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApproveProjectItemSampleCommand } from '../../models/approve-project-item-sample-command';
import { ApproveProjectItemSampleCommandResult } from '../../models/approve-project-item-sample-command-result';

export interface ApiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Params {
  
    /**
     * The command to approve or reject a project item Sample.
     */
    body?: ApproveProjectItemSampleCommand
}

export function apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch(http: HttpClient, rootUrl: string, params?: ApiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectItemSampleCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApproveProjectItemSampleCommandResult>;
    })
  );
}

apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch.PATH = '/api/ProjectItemSamples/ConsultantApproveOrRejectProjectItemSample';
